import ApplicationController from './application_controller'

export default class extends ApplicationController {
	submitForm() {
		const formToSubmit = this.element.closest('form')
		const valuesToSubmit = JSON.parse(this.element.dataset.values)
		for (const property in valuesToSubmit) {
			const dataInputElement = document.createElement('input')
			dataInputElement.type='hidden'
			dataInputElement.name=property
			dataInputElement.value=valuesToSubmit[property]
			formToSubmit.append(dataInputElement)
		}
		formToSubmit.requestSubmit()
	}
}
